import Log from "utils/log";
import { hiddenInput } from "mixins.css";

/**
 * @param {string} data - data to put on the clipboard
 */
export default data => {
  document.getSelection().removeAllRanges();

  const copyInput = document.createElement("input");
  copyInput.classList = hiddenInput;
  copyInput.value = data;
  document.body.appendChild(copyInput);
  copyInput.focus();
  copyInput.setSelectionRange(0, copyInput.value.length);

  if (document.queryCommandSupported("copy") && document.execCommand("copy")) {
    return true;
  } else {
    Log.warn("This browser doesn't support document.execCommand('copy')");
  }

  document.body.removeChild(copyInput);
};
